import { Check, Sparkles } from "lucide-react";

const PLANS = [
  {
    key: "start",
    name: "Start",
    desc: "Solidna strona docelowa dla mniejszej firmy PV.",
    features: [
      "Jednostronicowa strona (1 wersja)",
      "Formularz + powiadomienia e-mail",
      "Podstawowa analityka GA4",
      "Mobile-first design",
      "Publikacja w 7 dni",
    ],
    highlighted: false,
    cta: "Zacznijmy rozmowę",
  },
  {
    key: "growth",
    name: "Growth",
    desc: "Strona + ciągła opieka i optymalizacja — najlepszy stosunek wartości do kosztu.",
    features: [
      "Wszystko z pakietu Start",
      "Powiadomienia Telegram + e-mail",
      "Pełen GTM, eventy konwersji",
      "Comiesięczne A/B testy",
      "Optymalizacja prędkości i SEO",
      "Wsparcie e-mail (24h)",
    ],
    highlighted: true,
    cta: "Umów bezpłatną konsultację",
  },
  {
    key: "partner",
    name: "Partner",
    desc: "Pełna obsługa marketingowa — strona, kampanie, raporty.",
    features: [
      "Wszystko z pakietu Growth",
      "Prowadzenie Google Ads",
      "Dodatkowe landingi (montaż / fotowoltaika)",
      "Miesięczne raporty + spotkania",
      "Dedykowany opiekun",
      "Priorytetowe wsparcie (4h)",
    ],
    highlighted: false,
    cta: "Porozmawiajmy o współpracy",
  },
];

export default function AgencyPricing() {
  const scrollToForm = () => {
    const el = document.getElementById("kontakt");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="pakiety"
      data-testid="agency-pricing"
      className="relative py-20 lg:py-28 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-yellow">
            Pakiety
          </div>
          <h2 className="mt-3 font-heading font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            Trzy pakiety.{" "}
            <span className="text-white/40">Każdy zaczyna się od rozmowy.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-white/60 max-w-2xl leading-relaxed">
            Wybierz zakres, który pasuje do Twojej firmy. Cenę dobieramy
            wspólnie — po krótkiej rozmowie o Twoich potrzebach.
          </p>
        </div>

        <div className="mt-12 lg:mt-16 grid lg:grid-cols-3 gap-5 lg:gap-6 items-stretch">
          {PLANS.map((p) => (
            <PlanCard key={p.key} plan={p} onCta={scrollToForm} />
          ))}
        </div>

        <p className="mt-8 text-sm text-white/40 text-center">
          Bez długich umów. Bez gwiazdek.
        </p>
      </div>
    </section>
  );
}

function PlanCard({ plan, onCta }) {
  const { name, desc, features, highlighted, cta, key } = plan;

  return (
    <div
      data-testid={`agency-plan-${key}`}
      className={`relative flex flex-col rounded-3xl p-7 lg:p-9 transition-all ${
        highlighted
          ? "bg-gradient-to-b from-brand-yellow/[0.12] to-white/[0.02] ring-2 ring-brand-yellow shadow-[0_20px_70px_-20px_rgba(251,191,36,0.35)] lg:scale-[1.02]"
          : "bg-white/[0.03] ring-1 ring-white/10 hover:ring-white/20"
      }`}
    >
      {highlighted && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-full bg-brand-yellow text-brand-yellowFg px-3.5 py-1 text-[11px] font-bold uppercase tracking-wider shadow-md whitespace-nowrap">
          <Sparkles className="h-3.5 w-3.5" />
          Polecamy
        </div>
      )}

      <h3 className="font-heading font-extrabold text-white text-2xl tracking-tight">
        {name}
      </h3>
      <p className="mt-2 text-sm text-white/55 leading-relaxed min-h-[42px]">
        {desc}
      </p>

      <ul className="mt-7 space-y-3.5 flex-1">
        {features.map((f) => (
          <li key={f} className="flex items-start gap-3">
            <span
              className={`mt-0.5 grid place-items-center h-5 w-5 rounded-full flex-shrink-0 ${
                highlighted
                  ? "bg-brand-yellow text-brand-yellowFg"
                  : "bg-white/10 text-white"
              }`}
            >
              <Check className="h-3 w-3" strokeWidth={3} />
            </span>
            <span className="text-[14.5px] text-white/80 leading-snug">{f}</span>
          </li>
        ))}
      </ul>

      <button
        onClick={onCta}
        data-testid={`agency-plan-${key}-cta`}
        className={`mt-8 h-12 rounded-full font-semibold transition-all active:scale-95 ${
          highlighted
            ? "bg-brand-yellow hover:bg-brand-yellowHover text-brand-yellowFg shadow-md hover:shadow-lg"
            : "bg-white text-[#0B0F1A] hover:bg-white/95"
        }`}
      >
        {cta}
      </button>
    </div>
  );
}
